import React from "react";
import { BusinessServiceDescriptor } from "src/businessServices/BusinessServiseDescriptor";
import { ChatList } from "./ChatList";
import { ChatLabel } from "./ChatLabel";
import { getCachedChatListStore } from "./getCachedChatListStore";

export const bsChat: BusinessServiceDescriptor = {
  key: "chat",
  viewer(info, data) {
    return <ChatList store={getCachedChatListStore(info, data)} />;
  },
  async loadSettings(info) {
    return info;
  },
  renderSettings(_info, _store) {
    return <>В разработке...</>;
  },
  async saveSettings(_info, _values) {
    // eslint-disable-next-line no-console
    console.log("save");
  },
  renderTabLabel(info, data) {
    return <ChatLabel store={getCachedChatListStore(info, data)} data={data} />;
  },
};
